import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-reliantconfigs',
    templateUrl: './reliantconfigs.component.html',
    styleUrls: ['./reliantconfigs.component.scss'],
    standalone: false
})
export class ReliantConfigsComponent implements OnInit {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Url", "Url"),
  ];



  ngOnInit(): void {}
} 
